export const AUD_APPS_ACTI312_RACCOON_WEDDING = 'aud_apps_acti312_raccoon_wedding';

export const EXPERIMENTS = [AUD_APPS_ACTI312_RACCOON_WEDDING];
